export default __webpack_public_path__ + "static/media/tinder.3a5b2b1c.webp";